export const MEMBERSHIP_MARKETING_FEATURES = [
  { field: "api_access", label: "API Access", arLabel: "ربط API" },
  { field: "shopify_integration", label: "Shopify Integration", arLabel: "ربط مع Shopify" },
  { field: "woocommerce_integration", label: "WooCommerce Integration", arLabel: "ربط مع WooCommerce" },
  { field: "zatca_phase2_integration", label: "ZATCA Phase 2 Integration", arLabel: "ربط مع المرحلة الثانية للفوترة الإلكترونية" },
  { field: "zatca_simulation_sandbox", label: "ZATCA Simulation Sandbox", arLabel: "بيئة تجريبية لمحاكاة هيئة الزكاة والضريبة والجمارك" },
  { field: "sales_reports", label: "Sales Reports", arLabel: "تقارير المبيعات" },
  { field: "vat_report", label: "VAT Reports", arLabel: "تقارير ضريبة القيمة المضافة" },
  { field: "quotations", label: "Quotations", arLabel: "عروض الأسعار" },
  { field: "draft_invoices", label: "Draft Invoices", arLabel: "مسودات الفواتير" },
  { field: "customer_management", label: "Customer Management", arLabel: "إدارة العملاء" },
  { field: "product_management", label: "Product Management", arLabel: "إدارة المنتجات" },
  { field: "email_invoices", label: "Email Invoices", arLabel: "إرسال الفواتير عبر البريد الإلكتروني" },
  { field: "branding", label: "Custom Invoice Branding", arLabel: "تخصيص شعار الفاتورة" },
  { field: "customization", label: "Invoice Customization", arLabel: "تخصيص الفواتير" },
  { field: "multi_currency_invoicing", label: "Multi-Currency Invoicing", arLabel: "إصدار الفواتير بعملات متعددة" },
  { field: "support_247", label: "24/7 Support", arLabel: "دعم على مدار الساعة" },
];

export const defaultMembershipMarketingFeatures = Object.fromEntries(
  MEMBERSHIP_MARKETING_FEATURES.map(({ field }) => [field, 1])
);

export const membershipMarketingFeaturesFromPlan = (plan = {}) =>
  Object.fromEntries(
    MEMBERSHIP_MARKETING_FEATURES.map(({ field }) => [
      field,
      Number(plan?.[field] || 0),
    ])
  );
